/* eslint-disable no-useless-escape */

import React from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import _ from 'lodash';

import t from 'utils/translate';
import { FORM_MODEL } from 'admin/constants/common';

export type SingleSignOnFormValues = { organizationName: string };

type Props = {
	className?: string;
	children?: React.ReactNode;
	onSubmit?: (data: SingleSignOnFormValues) => any;
};

const SingleSignOnForm = ({
	className = '',
	onSubmit = _.noop,
	...props
}: Props & InjectedFormProps<SingleSignOnFormValues, Props>) => {
	return (
		<form className={className} onSubmit={props.handleSubmit(onSubmit)}>
			{props.children}
		</form>
	);
};

export default reduxForm<SingleSignOnFormValues, Props>({
	validate: values => {
		const errors: Partial<SingleSignOnFormValues> = {};

		if (!_.get(values, 'organizationName', '').trim()) {
			_.set(errors, 'organizationName', t('login.sso.organizationName.required'));
		}

		return errors;
	},
	destroyOnUnmount: true,
	form: FORM_MODEL.SINGLE_SIGN_ON,
})(SingleSignOnForm);
